class CardProductCarousel extends HTMLElement {
  constructor() {
    super()
    this.swiperInstance = null
    this.swiperContainer = this.querySelector('.swiper')
    this.swiperWrapper = this.querySelector('#swiper-wrapper')
    this.swiperNavigation = this.querySelector('#swiper-navigation')
    this.initializeSwiper()

    this.swiperContainer.addEventListener("mouseover", (event) => {
      if (window.innerWidth > 768) {
        this.swiperNavigation.classList.remove('md:hidden')
      }
    })

    this.swiperContainer.addEventListener("mouseout", (event) => {
      if (window.innerWidth > 768) {
        this.swiperNavigation.classList.add('md:hidden')
      }
    })

  }

  initializeSwiper() {
    this.swiperInstance = new Swiper(this.swiperContainer, {
      loop: true,
      enabled: true,
      slideInView: 1,
      slidesToMove: 1,
      autoplay: false,
      speed: 300,
      grabCursor: false,
      effect: "slide",
      stackMobile: false,
      freeModeMobile: false,
      no_swipe_mobile: false,

      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true,
      // },
      navigation: {
        nextEl: ".button-next",
        prevEl: ".button-prev",
      },
    })

  }

}

customElements.define('card-product-carousel', CardProductCarousel)